import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import 'react-widgets/dist/css/react-widgets.css';
import appConfig from '../../../../../app-config';
import { PICKUP, DELIVERY, DROPOFF } from '../../orderSettingTypes';
import UnavailableMessageWithButton from './UnavailableMessageWithButton';
import { Body, Caption1 } from '../../../../components/Typography';
import {
  renderTextToShow,
  timesAvailable,
  datesAvailable,
  renderMessageText,
} from '../utils/helper';
import TogglesAndDateTimeSelect from './TogglesAndDateTimeSelect';
import UnavailableProducts from './UnavailableProducts';

const Wrapper = styled.div`
  display: grid;
`;

const OrderMessage = styled(Caption1)`
  color: #737a87;
`;

const OrderFutureSchedule = ({
  availableTimes,
  selectedLocation,
  interSelectedDateTime,
  selectedDateTime,
  interOrderType,
  updateInterSelectedDateTime,
  getTimeIntervalsDate,
  confirmPickUpDetails,
  confirmDeliveryDetails,
  interDeliveryDetails,
  interPickUpDetails,
  interDropOffDetails,
  deliveryBusiness,
  isTimeNoLongerValid,
  resetIsTimeNoLongerValid,
  specialHours,
  orderPacingData,
  orderMessage,
  isOnline,
  confirmDropOffDetails,
  emptySearchBox,
  deepLinkParameters,
  isMarketplaceDelivery,
  setDeliveryTimeFormIsVisible,
  is_future_order_enabled,
  is_asap_order_enabled,
  onSeeMenu,
  cartReducer,
  setPickUpTimeFormIsVisible,
  selectMarketplacePickUpLocation,
  selectMarketplaceDeliveryLocation,
  updateInterPickUpDetails,
  updateInterDeliveryDetails,
  emptyCart,
  updateSelectedLocation,
  setShowConfirmButton,
  showConfirmButton,
  isMessageButtonEnabled,
}) => {
  const { errors } = cartReducer;
  const marketplaceSelectedLocation =
    interOrderType !== DELIVERY && selectedLocation
      ? selectedLocation
      : interOrderType === DELIVERY &&
        selectedLocation &&
        selectedLocation.deliveryBusiness
      ? selectedLocation.deliveryBusiness
      : null;
  const location = marketplaceSelectedLocation
    ? marketplaceSelectedLocation
    : interOrderType === PICKUP && interPickUpDetails
    ? interPickUpDetails
    : interOrderType === DELIVERY &&
      interDeliveryDetails &&
      interDeliveryDetails.deliveryBusiness
    ? interDeliveryDetails.deliveryBusiness
    : interOrderType === DROPOFF && interDropOffDetails
    ? interDropOffDetails
    : null;

  const orderEndTime =
    location &&
    availableTimes &&
    availableTimes.length &&
    (availableTimes.length > 1
      ? availableTimes[1].order_end_time
      : availableTimes[0].order_end_time);

  const minPrepTime =
    location && location.settings
      ? interOrderType == 'delivery'
        ? location?.settings?.min_delivery_time
        : interOrderType == 'pickup'
        ? location?.settings?.min_pickup_time
        : interOrderType == 'drop_off'
        ? location?.settings?.min_drop_off_time
        : null
      : null;

  const isAsapRadioDisabled = location ? !location.accepting_orders : true;

  const timesOptions =
    availableTimes && minPrepTime
      ? timesAvailable(availableTimes, minPrepTime, interSelectedDateTime)
      : [];
  const noHoursAvailableForChosenDay =
    location && timesOptions && timesOptions.length === 0;

  const noDatesAvailableForSchedule =
    location && location.settings
      ? moment(location.settings.max_future_order_date).isSame(
          moment().format('ddd MMM DD')
        ) ||
        datesAvailable(
          location.settings.max_future_order_date,
          specialHours,
          availableTimes
        ).length <= 1
      : true;

  const isScheduleRadioDisabled =
    (location && noDatesAvailableForSchedule && noHoursAvailableForChosenDay) ||
    !isOnline;

  const timeOptions = [
    {
      name: 'As soon as possible',
      value: 'asap',
      disabled: isAsapRadioDisabled,
    },
    {
      name: 'Schedule a time',
      value: 'schedule',
      disabled: isScheduleRadioDisabled,
    },
  ];
  const handleRadioChange = (event) => {
    const filteredArray = timeOptions.filter(
      (time) => time.value === event.target.value
    );
    updateInterSelectedDateTime({
      radioValue: {
        name: filteredArray[0].name,
        value: event.target.value,
      },
      dateTime: {
        date: null,
        time: {
          name: '',
          value: '',
        },
      },
    });
    resetIsTimeNoLongerValid();
  };
  const handleDateChange = (date, isClicked, shouldCheckForTime) => {
    const newDateTime = {
      radioValue: {
        name: 'Schedule a time',
        value: 'schedule',
      },
      dateTime: {
        date: {
          name:
            !isClicked && selectedDateTime?.dateTime?.date?.name
              ? selectedDateTime?.dateTime?.date?.name
              : moment(date).format('ddd MMM DD'),
          value:
            !isClicked && selectedDateTime?.dateTime?.date?.value
              ? selectedDateTime?.dateTime?.date?.value
              : moment(date).toString(),
          shouldCheckForTime:
            selectedDateTime?.dateTime?.date?.shouldCheckForTime ??
            shouldCheckForTime ??
            false,
        },
        time: {
          name:
            !isClicked && selectedDateTime?.dateTime?.time?.name
              ? selectedDateTime?.dateTime?.time.name
              : '',
          value:
            !isClicked && selectedDateTime?.dateTime?.time?.value
              ? selectedDateTime?.dateTime?.time.value
              : '',
        },
      },
    };
    updateInterSelectedDateTime(newDateTime);
    resetIsTimeNoLongerValid();
    if (location) {
      getTimeIntervalsDate(location.id, date);
    }
  };

  const handleSeeMenuButton = () => {
    if (interOrderType === PICKUP) confirmPickUpDetails(true);
    if (interOrderType === DELIVERY) confirmDeliveryDetails(true);
    if (interOrderType === DROPOFF) confirmDropOffDetails(true);
    if (appConfig.isGlobalSearchEnabled) {
      emptySearchBox();
    }
  };

  const messageToRender = location?.ordering_hours
    ? renderMessageText(
        interOrderType,
        location.ordering_hours,
        location.specialHours,
        location
      )
    : null;
  const showTimeSelecttion = (interOrderType, selectedLocation) => {
    const maxFutureOrderDate =
      interOrderType === 'pickup'
        ? selectedLocation?.max_future_order_date
        : selectedLocation?.deliveryBusiness?.max_future_order_date;
    const orderingHours =
      interOrderType === 'pickup' || interOrderType === 'drop_off'
        ? selectedLocation?.ordering_hours
        : selectedLocation?.deliveryBusiness?.ordering_hours;
    let hasOrderingHours = false;
    for (var key in orderingHours) {
      if (orderingHours[key][0] !== 'Closed') {
        hasOrderingHours = true;
      }
    }
    const isMaxOrderAfterNow = moment('2022-10-20 23:59:59').isAfter(moment());

    let show = false;
    if (interOrderType === DELIVERY && selectedLocation?.deliveryBusiness) {
      if (!selectedLocation?.deliveryBusiness?.is_order_ahead_enabled) {
        show = false;
      } else {
        if (
          !selectedLocation?.deliveryBusiness?.accepting_orders &&
          !hasOrderingHours
        ) {
          show = false;
        } else if (
          selectedLocation?.deliveryBusiness.accepting_orders ||
          (hasOrderingHours && is_future_order_enabled)
        ) {
          show = true;
          setShowConfirmButton(true);
        }
      }
    } else if (
      interOrderType === PICKUP &&
      !selectedLocation?.deliveryBusiness
    ) {
      if (!selectedLocation?.is_order_ahead_enabled) {
        show = false;
      } else {
        if (!selectedLocation?.accepting_orders && !hasOrderingHours) {
          show = false;
        } else if (
          selectedLocation?.accepting_orders ||
          (hasOrderingHours && is_future_order_enabled)
        ) {
          show = true;
          setShowConfirmButton(true);
        }
      }
    } else if (interOrderType === DROPOFF && selectedLocation) {
      show = true;
      setShowConfirmButton(true);
    }
    return show;
  };

  if (
    (location?.specialHours &&
      location.ordering_hours &&
      messageToRender &&
      !location.accepting_orders) ||
    (location && !location?.settings?.online && messageToRender)
  ) {
    return (
      <UnavailableMessageWithButton
        onClick={() => {
          onSeeMenu(location);
        }}
        marginTop='6px'
        title={messageToRender}
      />
    );
  } else {
    return (
      <Wrapper>
        {((interOrderType === DELIVERY &&
          (!selectedLocation?.deliveryBusiness?.is_order_ahead_enabled ||
            !selectedLocation?.deliveryBusiness?.accepting_orders) &&
          deliveryBusiness) ||
          (interOrderType === PICKUP &&
            (!selectedLocation?.is_order_ahead_enabled ||
              !selectedLocation?.accepting_orders) &&
            selectedLocation &&
            !selectedLocation.deliveryBusiness)) &&
          messageToRender && (
            <UnavailableMessageWithButton
              title={messageToRender}
              onClick={() => {
                if (isMarketplaceDelivery && interOrderType === DELIVERY) {
                  selectMarketplaceDeliveryLocation();
                  setDeliveryTimeFormIsVisible(false, selectedLocation);
                } else if (
                  isMarketplaceDelivery &&
                  interOrderType !== DELIVERY
                ) {
                  selectMarketplacePickUpLocation();
                  setPickUpTimeFormIsVisible(false, selectedLocation);
                } else {
                  if (interOrderType === DELIVERY) {
                    updateInterDeliveryDetails(selectedLocation);
                    confirmDeliveryDetails(true);
                  } else if (interOrderType === PICKUP) {
                    updateInterPickUpDetails(selectedLocation);
                    confirmPickUpDetails(true);
                  } else if (interOrderType === DROPOFF) {
                    confirmDropOffDetails(true);
                  }
                }
                updateInterSelectedDateTime({
                  radioValue: {
                    name: 'As soon as possible',
                    value: 'asap',
                  },
                  dateTime: {
                    date: {
                      name: moment().format('ddd MMM DD'),
                      value: moment().toString(),
                    },
                    time: {
                      name: '',
                      value: '',
                    },
                  },
                });
                handleSeeMenuButton();
                updateSelectedLocation(null);
              }}
              marginTop='5px'
            />
          )}
        {!isMarketplaceDelivery &&
          (is_future_order_enabled || is_asap_order_enabled) &&
          location?.is_order_ahead_enabled &&
          location?.accepting_orders && (
            <Body style={{ fontWeight: 'bold', marginBottom: '10px' }}>
              {renderTextToShow(interOrderType)}
            </Body>
          )}
        {appConfig?.specialOrderSettingMessage2 ? (
          <OrderMessage>{appConfig.specialOrderSettingMessage2}</OrderMessage>
        ) : null}
        {showTimeSelecttion(interOrderType, selectedLocation) && (
          <>
            <TogglesAndDateTimeSelect
              is_future_order_enabled={is_future_order_enabled}
              is_asap_order_enabled={is_asap_order_enabled}
              interSelectedDateTime={interSelectedDateTime}
              selectedDateTime={selectedDateTime}
              maxFutureOrderDate={
                location && location.settings
                  ? location.settings.max_future_order_date
                  : null
              }
              datesOptions={
                location && location.settings
                  ? datesAvailable(
                      location.settings.max_future_order_date,
                      specialHours,
                      availableTimes
                    )
                  : []
              }
              onDateChange={handleDateChange}
              timesOptions={timesOptions}
              onTimeChange={(time) => {
                resetIsTimeNoLongerValid();
                updateInterSelectedDateTime({
                  ...interSelectedDateTime,
                  dateTime: {
                    ...interSelectedDateTime.dateTime,
                    time: { name: time, value: time },
                  },
                });
              }}
              isTimeNoLongerValid={isTimeNoLongerValid}
              noTimesAvailable={timesAvailable.length}
              isAsapRadioDisabled={isAsapRadioDisabled}
              isScheduleRadioDisabled={isScheduleRadioDisabled}
              handleRadioChange={handleRadioChange}
              orderPacingData={orderPacingData}
              deepLinkParameters={deepLinkParameters}
              onSeeMenu={onSeeMenu}
              noDatesAvailableForSchedule={noDatesAvailableForSchedule}
              noHoursAvailableForChosenDay={noHoursAvailableForChosenDay}
              emptyCart={emptyCart}
              setShowConfirmButton={setShowConfirmButton}
              showConfirmButton={showConfirmButton}
              isMessageButtonEnabled={isMessageButtonEnabled}
              errors={errors}
              selectedLocationSettings={
                selectedLocation?.settings ?? location.settings
              }
              interOrderType={interOrderType}
              isOnline={isOnline}
            />
            {errors ? <UnavailableProducts cartErrorMessage={errors} /> : null}
          </>
        )}
      </Wrapper>
    );
  }
};

export default OrderFutureSchedule;
